<template>

<div>
    <button class="auth-action-link" type="button" v-b-modal.modal-reset-password>
        <span>Can't login?</span>
        <strong>Reset your password</strong>
    </button>

    <b-modal id="modal-reset-password" hide-header hide-footer centered>

        <b-alert v-model="showSuccess" variant="success">Email with reset link sent!</b-alert>
        <b-alert v-model="showError" variant="danger">{{ errorMessage }}</b-alert>

        <section class="modal-form text-center">
            <span class="brand-kicker">Account help</span>
            <h1>Reset password</h1>
            <form @submit.prevent="requestResetLink" class="form-grid">
                <div class="form-group">
                    <input required v-model="email" type="email" placeholder="user@example.com" class="form-control">
                </div>
                <button type="submit" class="btn btn-primary btn-lg w-100">Send reset link</button>
            </form>
        </section>

    </b-modal>
</div>

</template>

<script>
import AuthService from '@/services/auth.service.js'
import { BModal, VBModal } from "bootstrap-vue";

export default {
    name: 'ResetPasswordForm',
    components: {
        BModal,
    },
    directives: {
        'b-modal': VBModal
    },
    data () {
        return {
            email: null,

            showSuccess: false,
            showError: false,
            errorMessage: "Internal error",
        }
    },
    methods: {
        requestResetLink() {
            AuthService.requestPasswordChange(this.email)
                .then(() => {
                    this.showSuccess = true;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
}




</script>

<style>
.auth-action-link {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    border: 0;
    border-radius: 8px;
    padding: 0.75rem 0.85rem;
    background: rgba(55, 255, 139, 0.18);
    color: var(--ss-ink);
    text-align: left;
    font: inherit;
}

.auth-action-link span {
    color: var(--ss-muted);
    font-size: 0.92rem;
    font-weight: 800;
}

.auth-action-link strong {
    white-space: nowrap;
    font-weight: 950;
}

.modal-form {
    padding: 0.75rem;
}

.modal-form h1 {
    margin-bottom: 1rem;
    font-size: 2.5rem;
}

.form-grid {
    display: grid;
    gap: 0.75rem;
}
</style>
